import React from 'react';

const formatBytes = (value) => {
  if (!value || Number.isNaN(Number(value))) return null;
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let size = Number(value);
  let idx = 0;
  while (size >= 1024 && idx < units.length - 1) {
    size /= 1024;
    idx += 1;
  }
  return `${size.toFixed(size >= 10 || idx === 0 ? 0 : 1)} ${units[idx]}`;
};

const GoogleDriveSettingsModal = ({
  open,
  onClose,
  alertVariant,
  status,
  config,
  setConfig,
  loading,
  saving,
  testing,
  onConnect,
  onSave,
  onTest
}) => {
  if (!open) return null;

  const usage = formatBytes(config.storage?.usage);
  const limit = formatBytes(config.storage?.limit);

  return (
    <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.45)' }}>
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Google Drive</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p className="text-muted">
              Conecta tu cuenta de Google y elige la carpeta donde se guardarán los adjuntos de clientes,
              presupuestos, proyectos, tareas, soporte y las imágenes de email marketing y WhatsApp.
            </p>
            {status && (
              <div className={`alert alert-${alertVariant(status.type)}`}>
                {status.message}
              </div>
            )}

            <div className="border rounded p-3 mb-3">
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                <div>
                  <div className="fw-semibold">
                    Estado OAuth:{' '}
                    {loading ? (
                      <span className="text-muted">Comprobando...</span>
                    ) : config.connected ? (
                      <span className="text-success">Conectado</span>
                    ) : (
                      <span className="text-danger">No conectado</span>
                    )}
                  </div>
                  {config.connected && config.account?.email && (
                    <div className="small text-muted">
                      Cuenta: {config.account.name ? `${config.account.name} · ` : ''}{config.account.email}
                    </div>
                  )}
                  {config.connected && usage && (
                    <div className="small text-muted">
                      Almacenamiento: {usage}{limit ? ` de ${limit}` : ''}
                    </div>
                  )}
                  {config.error && <div className="small text-danger mt-1">{config.error}</div>}
                </div>
                <button type="button" className="btn btn-outline-primary btn-sm" onClick={onConnect} disabled={loading}>
                  {config.connected ? 'Reconectar con Google (OAuth)' : 'Conectar con Google (OAuth)'}
                </button>
              </div>
              <div className="small text-muted mt-2">
                La conexión OAuth es compartida con Google Calendar: al conectar se conceden ambos permisos.
              </div>
            </div>

            <form onSubmit={onSave}>
              <div className="mb-3">
                <label className="form-label">Carpeta raíz de Drive</label>
                <input
                  className="form-control"
                  value={config.driveFolderId}
                  onChange={(e) => setConfig((p) => ({ ...p, driveFolderId: e.target.value }))}
                  placeholder="ID de carpeta o URL https://drive.google.com/drive/folders/..."
                  disabled={saving}
                />
                <div className="form-text">
                  Puedes pegar el ID o la URL completa de la carpeta. Si lo dejas vacío, los archivos se suben a la raíz de "Mi unidad".
                </div>
              </div>

              {config.folder && (
                <div className="alert alert-success py-2">
                  Carpeta verificada: <strong>{config.folder.name}</strong>
                  {config.folder.webViewLink && (
                    <>
                      {' '}·{' '}
                      <a href={config.folder.webViewLink} target="_blank" rel="noreferrer">Abrir en Drive</a>
                    </>
                  )}
                </div>
              )}
              {config.folderError && (
                <div className="alert alert-warning py-2">{config.folderError}</div>
              )}

              <div className="d-flex gap-2 flex-wrap">
                <button className="btn btn-primary" type="submit" disabled={saving || loading}>
                  {saving ? 'Guardando...' : 'Guardar'}
                </button>
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={onTest}
                  disabled={testing || loading || !config.connected}
                  title={!config.connected ? 'Conecta primero con Google' : undefined}
                >
                  {testing ? 'Probando...' : 'Probar conexión'}
                </button>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <button className="btn btn-outline-secondary" onClick={onClose}>Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoogleDriveSettingsModal;
